<script setup lang="ts">
import { VueFinalModal } from 'vue-final-modal';
import { KeyRound } from 'lucide-vue-next';
import { UiModalHeader, ColoredButton } from '@/shared/ui';
import { useCustomToast } from '@/shared/lib';

const props = defineProps<{
  password: string;
}>();

const emit = defineEmits<{
  (e: 'close'): void;
}>();

const toast = useCustomToast();

const handleCopy = async () => {
  try {
    await navigator.clipboard.writeText(props.password);
    toast.showSuccessToast({ title: 'Senha copiada!', type: 'success' });
  } catch {
    toast.showErrorToast({ title: 'Falha ao copiar senha', type: 'error' });
  }
};

const handleClose = () => {
  emit('close');
};
</script>

<template>
  <VueFinalModal
    class="flex justify-center items-center"
    content-class="flex flex-col bg-white-01 rounded-2xl max-w-md w-full mx-4"
    overlay-transition="vfm-fade"
    content-transition="vfm-fade"
  >
    <UiModalHeader
      class="px-6 py-4 text-sm"
      title="Senha Gerada"
      @close="handleClose"
    />
    <div class="flex flex-col items-center px-8 pb-8">
      <KeyRound
        :size="32"
        class="text-gray-07 mb-4"
      />
      <div class="w-full bg-gray-100 rounded-lg p-4 mb-4">
        <p
          class="text-center font-mono text-lg select-all"
          data-testid="generated-password"
        >
          {{ password }}
        </p>
      </div>
      <ColoredButton
        text="Copiar"
        class="w-full mb-4"
        @click="handleCopy"
      />
      <div class="w-full bg-yellow-50 border border-yellow-200 rounded-lg p-3 mb-4">
        <p
          class="text-sm text-yellow-800 text-center"
          data-testid="password-warning"
        >
          Esta senha será exibida apenas uma vez. Anote-a antes de fechar.
        </p>
      </div>
      <ColoredButton
        text="Fechar"
        outlined
        color="gray-03"
        class="w-full"
        @click="handleClose"
      />
    </div>
  </VueFinalModal>
</template>
